import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const base = `${API_URL}/api/delivery-fleet`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

const listDrivers   = ()       => axios.get(`${base}/drivers`, auth()).then(r => r.data.drivers);
const createDriver  = (data)   => axios.post(`${base}/drivers`, data, auth()).then(r => r.data);
const getDriver     = (id)     => axios.get(`${base}/drivers/${id}`, auth()).then(r => r.data);
const updateDriver  = (id, data) => axios.put(`${base}/drivers/${id}`, data, auth()).then(r => r.data.driver);
const resetDriverPassword = (id) => axios.post(`${base}/drivers/${id}/reset-password`, {}, auth()).then(r => r.data.credentials);
const getDriverAgreementPdf = (id) => axios.get(`${base}/drivers/${id}/agreement-pdf`, auth()).then(r => r.data.url);

const getAgreementTemplate = () => axios.get(`${base}/agreement-template`, auth()).then(r => r.data.agreementText);
const saveAgreementTemplate = (agreementText) => axios.put(`${base}/agreement-template`, { agreementText }, auth()).then(r => r.data.agreementText);

const getShopifySettings = () => axios.get(`${base}/shopify-settings`, auth()).then(r => r.data);
const saveShopifySettings = (data) => axios.put(`${base}/shopify-settings`, data, auth()).then(r => r.data);
const sendShopifyTestOrder = () => axios.post(`${base}/shopify-settings/test-order`, {}, auth()).then(r => r.data);

const dispatchOrder = (orderId, data) => axios.post(`${base}/orders/${orderId}/dispatch`, data, auth()).then(r => r.data.delivery);
const cancelOffer   = (deliveryId) => axios.post(`${base}/deliveries/${deliveryId}/cancel-offer`, {}, auth()).then(r => r.data.delivery);
const listDeliveries = (status) => axios.get(`${base}/deliveries`, { ...auth(), params: status ? { status } : {} }).then(r => r.data.deliveries);
const markPaid      = (deliveryId) => axios.post(`${base}/deliveries/${deliveryId}/mark-paid`, {}, auth()).then(r => r.data.delivery);

const getAnalytics = () => axios.get(`${base}/analytics`, auth()).then(r => r.data);

// Public, no-auth tracking
const getTracking = (token) => axios.get(`${base}/track/${token}`).then(r => r.data);

const deliveryFleetService = {
  listDrivers, createDriver, getDriver, updateDriver, resetDriverPassword, getDriverAgreementPdf,
  getAgreementTemplate, saveAgreementTemplate,
  getShopifySettings, saveShopifySettings, sendShopifyTestOrder,
  dispatchOrder, cancelOffer, listDeliveries, markPaid,
  getAnalytics, getTracking,
};
export default deliveryFleetService;
